var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-rule-validity" },
    [
      _c(
        "yxt-radio-group",
        {
          on: { change: _vm.onChange },
          model: {
            value: _vm.formData.validType,
            callback: function ($$v) {
              _vm.$set(_vm.formData, "validType", $$v)
            },
            expression: "formData.validType",
          },
        },
        [
          _c("yxt-radio", { attrs: { label: 1 } }, [
            _vm._v(
              _vm._s(_vm.$t("pc_biz_rule_long_term_validity" /*'长期有效'*/))
            ),
          ]),
          _c("yxt-radio", { attrs: { label: 2 } }, [
            _vm._v(_vm._s(_vm.$t("pc_biz_rule_time_range" /*'指定范围'*/))),
          ]),
        ],
        1
      ),
      _vm.showTimes
        ? _c(
            "div",
            { staticClass: "mt16" },
            [
              _c("yxt-date-picker", {
                attrs: {
                  type: "daterange",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": _vm.$t("pc_biz_rule_to" /*至*/),
                  "start-placeholder": _vm.$t(
                    "pc_biz_rule_start_time" /*开始时间*/
                  ),
                  "end-placeholder": _vm.$t(
                    "pc_biz_rule_end_time" /*结束时间*/
                  ),
                },
                model: {
                  value: _vm.formData.validTimes,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "validTimes", $$v)
                  },
                  expression: "formData.validTimes",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }